<template>
    <div v-if="menu">
        <div class="ec-sidebar__secao">Unidade</div>
        <!-- com mais de uma unidade acessível, vira seletor para trocar de unidade -->
        <div v-if="quantidadeUnidades===null || quantidadeUnidades>1" class="ec-sidebar__troca">
            <seletor-unidade variante="lateral" :nome-atual="menu.nome" @carregado="quantidadeUnidades=$event.length"></seletor-unidade>
        </div>
        <div v-else class="ec-sidebar__unidade">
            <small>Unidade atual</small>
            {{ menu.nome }}
        </div>

        <a v-for="link in menu.links" :key="link.href" :href="link.href" class="ec-nav-link" :class="{ ativo: link.href==linkAtivo }">
            <i class="ec-nav-link__icone" :class="link.icone"></i>
            <span>{{ link.titulo }}</span>
        </a>

        <template v-if="menu.configuracoes.length">
            <div class="ec-sidebar__secao">Configurações da unidade</div>
            <a v-for="link in menu.configuracoes" :key="link.href" :href="link.href" class="ec-nav-link" :class="{ ativo: link.href==linkAtivo }">
                <i class="ec-nav-link__icone" :class="link.icone"></i>
                <span>{{ link.titulo }}</span>
            </a>
        </template>
    </div>
    <!-- página fora de uma unidade: só o seletor, para entrar em uma -->
    <div v-else-if="comSeletor && quantidadeUnidades!==0">
        <div class="ec-sidebar__secao">Unidade</div>
        <div class="ec-sidebar__troca">
            <seletor-unidade variante="lateral" @carregado="quantidadeUnidades=$event.length"></seletor-unidade>
        </div>
    </div>
</template>

<script>
import SeletorUnidade from './SeletorUnidade.vue'

export default {
    components:{ SeletorUnidade },
    props:{
        // exibe o seletor mesmo quando a página não é de uma unidade
        comSeletor:{ type:Boolean, default:false }
    },
    data(){
        return{
            quantidadeUnidades:null
        }
    },
    computed:{
        menu(){
            return this.$store ? this.$store.state.menuUnidade : null
        },
        // marca o link mais específico que corresponde à URL atual
        linkAtivo(){
            if(!this.menu){
                return null
            }
            const caminho = window.location.pathname.replace(/\/+$/,'')
            const todos = this.menu.links.concat(this.menu.configuracoes)
            let melhor = null
            todos.forEach(link => {
                const confere = link.exato ? caminho==link.href : (caminho==link.href || caminho.startsWith(link.href+'/'))
                if(confere && (!melhor || link.href.length > melhor.length)){
                    melhor = link.href
                }
            })
            return melhor
        }
    }
}
</script>
